module.exports = __webpack_public_path__ + "components/country-flag/static/sg-d9221e245949c127076105c955d37b5b.svg";